<template>
	<div v-show="sureDialog" class="self-dialog-pop"  ref="dialogWrap">
			<div class="self-dialog-content" :style="dialogTopStyle">
			    <div class="content-wrap">
			       <p>{{dialogText}}</p>
			    </div>
			    <div class="btn-wraps">
			      <a href="javascript:;"  @click="dialogCancel">取消</a>
			      <a href="javascript:;"  @click="dialogSureFun">确定</a>
			    </div>
			</div>
			<home :ishome=0></home>
  </div>
</template>
<script>
	
import home from '../common/home.vue'
export default{
	props:{
		dialogtype:Number,//0 不显示弹框，1，删除祝福，2删除消息祝福，3，删除留言（回复)4,显示弹框
		operid:Number,
	},
	data(){
		return {
			dialogModel:0,
			dialogText:'',
			dialogTopStyle:{
				top:"50%"
			}
		}
	},
	components:{
	home
	},
	watch:{
		dialogtype(cval){
			console.log("dialogtype",cval)
			this.dialogModel=cval;
			if(cval==1||cval==2){
				this.dialogText='确定要删除祝福吗？'
			}
			if(cval==3){
				this.dialogText='确定要删除留言吗？'
			}
			if(cval!=0){
				this.disableScroll();
				if(this.isIOS8()){
					this.resetIos8DialogTop();
				}
			}
		}
	},
	computed:{
		sureDialog(){
			if(this.dialogModel==0){
				return false;
			}else{
				return true;
			}
		}
		
	},
	methods:{
		disableScroll:function(){
          var dialogWrap= this.$refs.dialogWrap;
          dialogWrap.ontouchmove = function(e){ e.preventDefault()};
        }, 
        isIOS8(){
	      var ua = window.navigator.userAgent.toLowerCase();
	      return /iphone os ([8]+)_/.test(ua)
	    },
	    resetIos8DialogTop(){
	      let scrollWrap=document.querySelector('.scroll-container');
	      let widowA=window.screen.availHeight;
	      var top=scrollWrap.scrollTop + widowA/2 + 140;
	      console.log("重置弹框top",scrollWrap.scrollTop,widowA,top)
	      this.dialogTopStyle.top=top + 'px';
	       // document.querySelector('.self-dialog-content').style.top=top + 'px';
	        // console.log("重置后的高度",document.querySelector('.self-dialog-content').style.top)
	    },
		dialogCancel(){
			this.dialogModel=0;
			this.$emit('close')
		},
		dialogSureFun(){
			if(this.dialogtype==1){
				this.$store.dispatch('doDelWish',{wishId:this.operid});
			}
			if(this.dialogtype==2){
				this.$store.dispatch('doDelWish',{wishId:this.operid});
				this.$emit('wishdel')
			}
			if(this.dialogtype==3){
				this.$store.dispatch('doBirthdayWishReplyDel',{replyId:this.operid});
			}
			this.dialogCancel();
		}
	},
	mounted(){

	}
}
</script>